module.exports = __webpack_public_path__ + "static/media/camera.2d692ba1.png";